import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = Status

const initialState: State = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.HIDE_WELCOME_POPUP_ASYNC,
    Actions.HIDE_WELCOME_POPUP_SUCCESS,
    Actions.HIDE_WELCOME_POPUP_FAIL,
    {}
  >,
) => {
  switch (action.type) {
    case Actions.HIDE_WELCOME_POPUP_ASYNC:
    case Actions.HIDE_WELCOME_POPUP_SUCCESS:
    case Actions.HIDE_WELCOME_POPUP_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
